import { createContext, useContext } from 'react'
import { useGastos } from '../hooks/useGastos'

const GastosContext = createContext(null)

export function GastosProvider({ children }) {
  return <GastosContext.Provider value={useGastos()}>{children}</GastosContext.Provider>
}

export function useGastosContext() {
  return useContext(GastosContext)
}
